export const SEARCH_PARAM_EXPLORATION_ID = 'exploration'
export const SEARCH_PARAM_PRESENTATION_MODE = 'presentation_mode'
export const SEARCH_PARAM_FOCUS_PANEL = 'focus'
